import React, { memo } from "react";

interface LegendProps {
  data: Array<{ name: string; value: number }>;
  colors: string[];
}

// Custom Legend Component
const PieChartDataHandler: React.FC<LegendProps> = ({ data, colors }) => {
  if (!data || data.length === 0) {
    return <p style={{ textAlign: "center", fontSize: 14 }}>No data available</p>;
  }

  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px" }}>
      {data.map((entry, index) => {
        const percentage = total ? ((entry.value / total) * 100).toFixed(1) : "0.0";
        return (
          <div
            key={index}
            style={{ display: "flex", alignItems: "center", marginRight: 10 }}
          >
            <div
              style={{
                width: 12,
                height: 12,
                backgroundColor: colors[index % colors.length], // Prevents index out of bounds
                marginRight: 5,
                borderRadius: 3,
              }}
            ></div>
            <span style={{ fontSize: '14px', fontWeight: "400", color: '#4F4F4F', marginRight: 10 }}>{entry.name}</span>
            <span style={{ fontSize: '14px', fontWeight: "600", color: '#4F4F4F' }}>
              {percentage}%
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default memo(PieChartDataHandler);
